<template lang="pug">
  div
    .container
      listagem-paineis(
        v-if="paineis && paineis.length > 0"
        :paineis="paineis"
        :isMyProject="false"
        @openModal="openModal"
      )
    modal-cadastro-painel(
      v-if="modal"
      :idPainel="idPainel"
      @closeModal="closeModal()"
      @refreshList="getMyProjects()"
    )
    .container-center
      div(v-if="paineis && paineis.length == 0")
        .alert Nenhum painel compartilhado até o momento
</template>

<script>
import BemVindo from '@/screens/demandas/components/BemVindo'
import Card from '@/screens/demandas/components/Card'
import ModalCadastroPainel from '@/screens/demandas/components/ModalCadastroPainel'
import ListagemPaineis from '@/screens/demandas/components/ListagemPaineis'
import { mapActions } from 'vuex'

export default {
  components: {
    BemVindo,
    ListagemPaineis,
    Card,
    ModalCadastroPainel
  },

  data () {
    return {
      paineis: null,
      modal: false,
      idPainel: null
    }
  },

  methods: {
    ...mapActions({
      findPaineis: 'paineis/findByFilter'
    }),

    async getProjects () {
      const paineis = await this.findPaineis({
        isCompartilhado: true,
        ordem: 'dataCriacao',
        ordemDirecao: 'DESC'
      })

      this.paineis = paineis
    },

    closeModal () {
      this.modal = false

      this.getProjects()
    },

    openModal (id) {
      this.idPainel = id
      this.modal = true
    }
  },

  mounted () {
    this.getProjects()
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.container {
  height: 100%;
}

.container-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 80vh;
}

.new-project {
  margin-bottom: 40px;
}

.alert {
  display: flex;
  flex-direction: center;
  justify-content: center;
  color: $lightgray-color;
  font-size: 21px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/screens/demandas/components/PaineisCompartilhados.vue